import axios from 'axios';
import { downloadExcelFile, downloadFile } from 'app/api/apiUtil';

const api = '/api/provision-sheets';

export const getProvisionSheets = params => {
  const queryParams = params
    ? Object.keys(params)
        .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
        .join('&')
    : '';

  return axios.get(`${api}?${queryParams}&cacheBuster=${new Date().getTime()}`);
};

export const getLatestProvisionSheetGroup = () => {
  return axios.get(`${api}/group/latest`);
};

export const downloadProvisionSheetById = async id => {
  const response = await axios.get(`${api}/download/${id}?cacheBuster=${new Date().getTime()}`, {
    responseType: 'blob', // Important for downloading files
  });

  downloadFile(response);
};

export const handleDownloadExcelById = async id => {
  const response = await axios.get(`${api}/vyplatit-pdf/${id}?cacheBuster=${new Date().getTime()}`, {
    responseType: 'blob', // Important for downloading files
  });

  downloadExcelFile(response);
};

export const regenerateProvisionSheets = () => {
  return axios.get(`${api}/regenerate?cacheBuster=${new Date().getTime()}`);
};

export const generateProvisionSheets = () => {
  return axios.get(`${api}/generate?cacheBuster=${new Date().getTime()}`);
};

export const vyplatitPripraveneProvizie = async () => {
  const response = await axios.get(`${api}/vyplatit?cacheBuster=${new Date().getTime()}`, {
    responseType: 'blob', // Important for downloading files
  });

  downloadExcelFile(response);
};

export const acceptProvisionSheet = id => {
  return axios.get(`${api}/accept/${id}?cacheBuster=${new Date().getTime()}`);
};

export const prepareForVyplatenieProvisionSheet = id => {
  return axios.get(`${api}/prepare-for-vyplatenie/${id}?cacheBuster=${new Date().getTime()}`);
};
